module.exports = __webpack_public_path__ + "imgs/leafwell-hero.22863f66f5500490052714ce373a7103.png";